import React from 'react';
import AnnouncementItem from './AnnouncementItem.jsx';
import {Link} from "react-router-dom";
import {Businesses} from 'api';
import {connect} from 'react-redux';
import {ShowIf} from 'components/utils';

class AnnouncementBlock extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    if (this.props.myBusinesses) {
      this.getAnnouncement(this.props.myBusinesses.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.myBusinesses) {
      this.getAnnouncement(nextProps.myBusinesses.id);
    }
  }

  getAnnouncement(businessId) {
    if (businessId) {
      const params = {
        id: businessId,
        filter: {
          limit: 3
        }
      };
      Businesses.actions.announcements.request(params).then(response => {
        if (response && response.data) {
          let announcements = [];
          response.data.map((item, idx) => {
            announcements.push(item);
          });
          this.setState({data: announcements});
        }
      });
    }
  }

  render() {
    if (this.state.data.length === 0) {
      return null;
    }
    return (
      <div className='the-news-wrap-item'>
        <section className="announcement-news">
          <h2 className='announcement-title'>Thông báo</h2>
          <div className='announcement-list'>
            {
              this.state.data.map((item, idx) => {
                return (
                  <AnnouncementItem key={idx} {...item} />
                );
              })
            }
          </div>
          <p className='view-all'>
            <Link to="/my-business/announcements" className='view-all-link'>Xem tất cả</Link>
          </p>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    myBusinesses: state.myBusinesses.mainBusiness
  };
};

export default connect(mapStateToProps)(AnnouncementBlock);



// WEBPACK FOOTER //
// ./components/partials/announcement-block/AnnouncementBlock.jsx